<script setup>
    import { onMounted, ref, reactive } from 'vue';
import PageHeader from '@/Components/PageHeader.vue';
    import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
    import { Head, Link } from '@inertiajs/inertia-vue3';
    import BaseIcon from "@/Components/BaseIcon.vue";
    import {
        mdiArrowRightBoldCircle, mdiTrashCan, mdiCog, mdiArrowUpCircle, mdiArrowDownCircle, mdiArrowDownBold, mdiClipboardEdit, mdiCashPlus, mdiPlusCircle, mdiInformationOutline
    } from "@mdi/js";
    import 'vue-cal/dist/vuecal.css'
    import CardBox from "@/Components/CardBox.vue";
    import BaseButtons from "@/Components/BaseButtons.vue";
    import BaseButton from "@/Components/BaseButton.vue";
    import NotificationAlert from "@/Components/NotificationAlert.vue";
    import { Inertia } from '@inertiajs/inertia';


    const props = defineProps({
        titleup: String,
        collaboratorActives: Object,
        //collaboratorsdp: Object,
        message: String,
        relojes: Array,
        entidades: Object
    });

    console.log(props.entidades)
    const collaborators = ref((props.entidades.length > 1 ? [] : props.collaboratorActives));
    const setReloj = ref(-1)
    const infoReloj = ref('')
    const entidad = ref(-1)

    const listarColaboradores = async () => {
        let url = '/config/relojasistencia/collaborators?entity='+entidad.value;
        loading.value = true;
        await axios.get(url).then((response) => {
            let respuesta = response.data;
            collaborators.value = respuesta.datalist;
            console.log(collaborators.value);
            
            if(!respuesta.success) {
                showAlert(respuesta.message, 'warning', 30)
                loading.value = false
            } 
            console.log(respuesta.message);
        }).catch((error) => {

            //console.log(error);
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                showAlert(error.response.data.message, 'danger', 60)
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser 
                // and an instance of http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
                howAlert(error.message, 'danger', 60)
            }
        });
        loading.value = false
    }

    const collaboratorsdp = ref([]);
    const listarRelojUsers = async () => {
        //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
        // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
        let url = '/config/relojasistencia/users?id='+setReloj.value;
        loading.value = true;
        await axios.get(url).then((response) => {
            let respuesta = response.data;
            collaboratorsdp.value = respuesta.datalist;
            console.log(collaboratorsdp.value);
            
            if(!respuesta.success) {
                showAlert(respuesta.message, 'warning', 30)
                loading.value = false
            } 
            console.log(respuesta.message);
        }).catch((error) => {

            //console.log(error);
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                showAlert(error.response.data.message, 'danger', 60)
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser 
                // and an instance of http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
                howAlert(error.message, 'danger', 60)
            }
        });
        loading.value = false
    }

    const claveRelojUser = ref('');
    const rolRelojUser = ref(0)
    const updateRelojUser = async (id_user = 0, nombre = '', clave='', rol='') => {

        let url = '/config/relojasistencia/userstore';
        loading.value = true;
        await axios.put(url, {
            'id' : setReloj.value,
            'id_user' : id_user,
            'nombre': nombre,
            'clave' : clave,
            'rol': rol
        }).then((response) => {
            let respuesta = response.data;
            //console.log(collaboratorsdp.value);
            if(!respuesta.success) {
                showAlert(respuesta.message, 'warning', 30)
            } else {
                showAlert('Registro actualizado', 'success') 
                listarRelojUsers()
            }
            console.log(respuesta.message);
        }).catch((error) => {
            showAlert(error.message, 'danger', 60)
            console.log(error);
        });
        loading.value = false

    }

    const deleteRelojUser = async (id_user = 0, nombre='') => {
    
        let valid = false;
        valid = confirm("Seguro de eliminar "+nombre+" en el dispositivo")
        if (valid) {

            let url = '/config/relojasistencia/userdelete';
            loading.value = true;
            await axios.put(url, {
                'id' : setReloj.value,
                'id_user' : id_user,

            }).then((response) => {
                let respuesta = response.data;
                //console.log(collaboratorsdp.value);
                if(!respuesta.success) {
                    showAlert(respuesta.message, 'warning', 30)
                } else {
                    showAlert('Registro actualizado', 'success') 
                    listarRelojUsers()
                }
                console.log(respuesta.message);
            }).catch((error) => {
                showAlert(error.message, 'danger', 60)
                console.log(error);
            });
            loading.value = false
        }

    }

    const setAdmin = ref(false)
    const changeSetAdmin = () => {
        if (setAdmin.value) {
            claveRelojUser.value = '130116'
            rolRelojUser.value = 14
        } else {
            claveRelojUser.value = ''
            rolRelojUser.value = 0
        }
        
    }

    const changeSetReloj = async () => {
        let url = '/config/relojasistencia/setreloj';
        loading.value = true;
        await axios.put(url, {
            'id' : setReloj.value
        }).then((response) => {
            let respuesta = response.data;
            //console.log(collaboratorsdp.value);
            if(!respuesta.success) {
                showAlert(respuesta.message, 'warning', 30)
            } else {
                showAlert(respuesta.message, 'success')
                infoReloj.value = respuesta.info
                collaboratorsdp.value = []
            }
            console.log(respuesta.message);
        }).catch((error) => {
            showAlert(error.message, 'danger', 60)
            console.log(error);
        });
        loading.value = false
    }

    const loading = ref(false)

    const isAlertActive = ref(false)
    const isAlertDangerActive = ref(false)
    const messageAlert = ref('')
    const messageLastAction = ref('')
    const messageError = ref('')
    /* const error = ref(0)
    const errors = ref([]) */
    const colorAlert = ref('success')
    const errormsg = ref(null)
    const errors = ref(0)
    const alertIndex = ref(0)

    const showAlert = (message = '', type, time = 1) => {

        messageAlert.value = message
        colorAlert.value = type// <-- Tipo define el color
        isAlertActive.value = true

        // grabar última acción
        messageLastAction.value = message

        /* if (color == 'danger') {
            isAlertDangerActive.value = true
        } else {
            isAlertActive.value = true
        } */
        setTimeout(() => {
            isAlertActive.value = false
            //messageAlert.value = '' <-- Comentar para que no halla error de prop indefined en el componente NotificationAlert
            /* if (color == 'danger') {
                isAlertDangerActive.value = false
            } else {
                isAlertActive.value = false
            } */
            errormsg.value = ref(null)
            errors.value = ref(0)
            alertIndex.value = ref(0)
            //isActionMassive.value = false
        }, time * 1000)// LRR bind(this)


    }

    const formatDate = (date, type='') => {
        //var now = new Date().toLocaleDateString()
        var date = new Date(date)// <-- Con let no funcionaba
        //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
        let result =  (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
        if (type == 'ISO') {
            result = date.getFullYear() + '-' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '-' +(date.getDate() > 9 ? '' : '0') + date.getDate()
        }
        return result
    }

    // Ejecutar
    const ejecutarConfirm = ref([])
    const crearStory = (type = 1) => {

        let ruta = 'student-store-story'
        Inertia.put(route(ruta, {
            //'id' : rowID.value,
            'anio' : '2023',
            'type' : type

            }
        ))

    }

    const ejecutar = (type = '') => {

        let ruta = 'student-ejecutar'
        Inertia.put(route(ruta, {
            //'id' : rowID.value,
            'type' : type

            }
        ))

    }

    const cleanVal = () => {

        
    messageLastAction.value = ''
    messageError.value = ''
    idStudentOrder.value = 0
    pinSecurity.value = ''
    }


    const showAyuda = ref([
        {'ordenpago': false},
        {'configuracion': false},
        {'cobranzas': false}
    ])

</script>

<template>
    <Head title="Configuración Reloj de Asistencia" />

    <NotificationAlert v-model="isAlertActive" :message="messageAlert" :color="colorAlert" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <PageHeader title="Aulas asignadas" />
        </template>

        <!-- <CardBoxModal v-model="showDialog" :title="(selectedEvent.title ? selectedEvent.title : 'Información del evento')"
            hasCancel>
            <strong>{{ selectedEvent.start && selectedEvent.start.format('DD/MM/YYYY') }} :
                {{ selectedEvent.start && selectedEvent.start.formatTime() }} -
                {{ selectedEvent.end && selectedEvent.end.formatTime() }}
            </strong>
            <p v-html="selectedEvent.contentFull" />
        </CardBoxModal> -->

        <div class="pb-12">
            <!-- Loader -->
            <div v-if="loading" class="flex flex-col justify-center items-center md:h-[calc(100vh_-113px)] h-[calc(100vh-_114px)] absolute bottom-0 bg-white w-full z-50 bg-opacity-80">
                <div class="border-gray-300 h-20 w-20 animate-spin rounded-full border-8 border-t-rose-600 mb-10" />
                <p class="text-rose-600">Espere por favor ...</p>
            </div>
            
            <div class="mx-auto sm:px-6 lg:px-8 px-4 pt-12 pb-6" :class="loading ? 'pointer-events-none' : ''"><!--max-w-7xl-->
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
                        <!-- <div>
                            <div class="mb-2">
                                <h2>.</h2>
                            </div>

                        </div> -->

                        <CardBox class="mb-6" has-table>
                            <!-- lg:justify-end -->
                            <div class="w-full overflow-x-auto">
                                <li> Una vez cargado el dispositivo podrá actualizar la información de cada colaborador en el dispositivo, su nombre, tipo y clave. </li>
                                <li> Una vez estén actualizados los colaboradores, estos deben ir al reloj para configurar su huella. </li>
                                <li> El nombre en el reloj soporta hasta 27 carácteres así que si el nombre es mayor entonces se cortará en el reloj. </li>
                                <br>
                                <div class="grid grid-cols-2 gap-3">
                                    <div class="col-span-2 xl:col-span-1">
                                        <!-- {{ entidades }} -->
                                        <div v-if="entidades.length > 1" class="relative mb-4">
                                            <label class="block font-bold mb-2 ml-2">Entidad</label>
                                            <select v-model="entidad" @change="listarColaboradores()"
                                                class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                                                <option value="-1" selected>Seleccionar Entidad</option>
                                                <option value="0" selected>Todos</option>
                                                <option v-for="(option, index) in entidades" :value="option.id" :key="option.id">{{ option.label }}</option>
                                            </select>
                                            
                                        </div>
                                    </div>
                                    <div class="col-span-2 xl:col-span-1">
                                        <!-- {{ relojes }} -->
                                        <div v-if="relojes.length > 0" class="relative mb-4">
                                            <label class="block font-bold mb-2 ml-2">Reloj</label>
                                            <select v-model="setReloj" @change="changeSetReloj()"
                                                class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                                                <option value="-1" selected>Seleccionar reloj</option>
                                                <option v-for="(option, index) in relojes" :value="index" :key="option">{{ option }}</option>
                                            </select>
                                            <span>{{ infoReloj }}</span>
                                        </div>
                                        <div class="relative ml-2">
                                            <BaseButtons v-if="setReloj >= 0" type="justify-start" no-wrap>
                                                <BaseButton
                                                    color="info"
                                                    label="Listar usuarios Disp."
                                                    small
                                                    @click="listarRelojUsers()"
                                                />
                                                <!-- <BaseButton
                                                    v-if = "ejecutarConfirm['storyantiguos'] == 1"
                                                    color="warning"
                                                    label="Confirmar"
                                                    small
                                                    @click="(crearStory(1), (ejecutarConfirm['storyantiguos']=0))"
                                                /> -->
                                                
                                            </BaseButtons>
                                        </div>
                                        <!-- Opciones de admin-->
                                        <!-- {{ setAdmin + ' rol: ' +rolRelojUser + ' clave: ' +claveRelojUser }} -->
                                        <div v-if="Object.keys(collaboratorsdp).length > 0" class="p-4">
                                            <div>
                                                <label class="checkbox">
                                                <input v-model="setAdmin" type="checkbox" @change="changeSetAdmin()"/>
                                                <span class="check mr-2"> Establecer como Admin a un colaborador</span>
                                                </label>
                                            </div>
                                            <div v-if="setAdmin">
                                                <select v-model="rolRelojUser" 
                                                class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                                                <option value="0" selected>Normal</option>
                                                <option value="2">Registrador</option>
                                                <option value="12">Supervisor</option>
                                                <option value="14">Admin</option>
                                                <!-- <option v-if="template=='calificationsugel'" value="B5">Promedio Anual</option> -->
                                                </select>

                                                <input name="relojclave" class="ml-3 rounded-lg" type="text" v-model="claveRelojUser">
                                            </div>

                                        </div>

                                    </div>
                                </div>
                                
                                
                            </div>
                        </CardBox>
                    </div>
                </div>
            </div>
            
            <!-- Sección listas -->
            <div class="sm:px-6 lg:px-8 px-4 mx-auto pb-4">
                <div class="grid gap-4 cols-1 xl:grid-cols-2 mb-6">
                    <div class=" bg-white rounded-lg shadow-lg p-6">
                        <div>
                            <h5 class="text-xl text-gray-900 font-bold mb-8 ml-3">Colaboradores activos ({{ collaborators.length }})</h5>
                            <table class="min-w-full text-sm font-light table-responsive-wfull">
                                <thead class="border-b bg-white font-medium dark:border-neutral-500 dark:bg-neutral-600">
                                    <tr>
                                        <!-- <th scope="col" class="">#</th> -->
                                        <th scope="col" class="">ID</th>
                                        <th scope="col" class="">Colaborador</th>
                                        <th v-if="Object.keys(collaboratorsdp).length > 0" scope="col" class="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="collaborators.length" v-for="(client, index) in collaborators"
                                        :key="client.id"
                                        class="border-b bg-neutral-100 dark:border-neutral-500 dark:bg-neutral-700">
                                        <!-- <td class="whitespace-nowrap border-none font-medium border-r-0">{{ index + 1 }}
                                        </td> -->
                                        <td class="whitespace-nowrap border-none font-medium border-r-0">{{ client.id }}
                                        </td>
                                        <td class="whitespace-nowrap border-none">{{ client.apellidos }} {{ client.nombres }}</td>
                                        <!-- Object.keys(collaboratorsdp).length > 0  -->
                                        <td v-if="setReloj >= 0" class="whitespace-nowrap border-none" style="padding:0;">
                                            <div class="text-center">
                                                <BaseButton
                                                    title="Actualizar en el dispositivo"
                                                    color="warning"
                                                    small
                                                    :icon="mdiArrowRightBoldCircle"
                                                    @click="updateRelojUser(client.id, client.apellidos + ' ' + client.nombres, claveRelojUser, rolRelojUser)"
                                                />
                                            </div>
                                            <!--label="Actualizar en Disp." <small @click="updateRelojUsers(client.id, client.apellidos + ' ' + client.nombres, claveRelojUser, rolRelojUser)" class="text-blue-700 hover:text-green-600">Actualizar en Disp.</small> -->
                                        </td>
                                    </tr>
                                    <tr v-else class="border-b bg-white dark:border-neutral-500 dark:bg-neutral-600">
                                        <td class="whitespace-nowrap border-none font-medium" colspan="2"><span> No existen
                                                registros …</span></td>

                                    </tr>

                                </tbody>
                            </table>
                        </div>
                        <hr class="h-px my-8 bg-gray-200 border-0 dark:bg-gray-700">
                        <!-- <div class="mt-6">
                            <h5 class="text-xl text-gray-900 font-bold mb-8 ml-3">Colaboradores en dispositivo</h5>
                            <table class="min-w-full text-sm font-light table-responsive-wfull">
                                <thead class="border-b bg-white font-medium dark:border-neutral-500 dark:bg-neutral-600">
                                    <tr>
                                        <th scope="col" class="">#</th>
                                        <th scope="col" class="">Alumno</th>
                                        <th scope="col" class="">Fecha de compromiso</th>
                                        
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="colaboradoresdp.length" v-for="(client, index) in colaboradoresdp"
                                        :key="client.id"
                                        class="border-b bg-neutral-100 dark:border-neutral-500 dark:bg-neutral-700">
                                        <td class="whitespace-nowrap border-none font-medium border-r-0">{{ index + 1 }}
                                        </td>
                                        <td class="whitespace-nowrap border-none">{{ client.apellidos }} {{ client.nombres }}</td>
                                        <td class="whitespace-nowrap border-none" :class="(client.fecha_compromiso_pago && client.fecha_compromiso_pago < (formatDate(new Date(), 'ISO')) ? 'text-red-600' : '')"> {{ client.fecha_compromiso_pago }} </td>
                                    </tr>
                                    <tr v-else class="border-b bg-white dark:border-neutral-500 dark:bg-neutral-600">
                                        <td class="whitespace-nowrap border-none font-medium" colspan="3"><span> No existen
                                                registros …</span></td>

                                    </tr>

                                </tbody>
                            </table>
                        </div> -->
                        
                    </div>
                    <div class=" bg-white rounded-lg shadow-lg p-6">
                        <h5 class="text-xl text-gray-900 font-bold mb-8 ml-3">Colaboradores en dispositivo ({{ Object.keys(collaboratorsdp).length  }})
                        </h5>
                    <!-- {{ collaboratorsdp }} -->
                        <table class="min-w-full text-sm font-light table-responsive-wfull">
                            <thead class="border-b bg-white font-medium dark:border-neutral-500 dark:bg-neutral-600">
                                <tr>
                                    <th scope="col" class="">ID</th>
                                    <th scope="col" class="">Colaborador</th>
                                    <!-- <th scope="col" class="">CardNumber</th> -->
                                    <th scope="col" class="">UID</th>
                                    <th scope="col" class="">Tipo</th>
                                    <th scope="col" class="">Clave</th>
                                    <th scope="col" class="">Action</th>
                                </tr>
                            </thead>
                            <tbody>

                                <tr v-for="(client, index) in collaboratorsdp"
                                    :key="client"
                                    class="border-b bg-neutral-100 dark:border-neutral-500 dark:bg-neutral-700">
                                    <!-- <td class="whitespace-nowrap border-none font-medium border-r-0">{{ index + 1 }}
                                    </td> -->
                                    <td class="whitespace-nowrap border-none font-medium border-r-0">{{ client[0] }}
                                    </td>
                                    <td class="whitespace-nowrap border-none">{{ client[1] }} </td>
                                    <!-- <td class="whitespace-nowrap border-none">{{ client[2] }} </td> -->
                                    <td class="whitespace-nowrap border-none">{{ client[3] }} </td>
                                    <td class="whitespace-nowrap border-none">{{ client[4] == 14 ? 'Admin' : (client[4] == 12 ? 'Super' : 'Normal') }} </td>
                                    <td class="whitespace-nowrap border-none" :title="client[5]"> {{ client[5] ? '*****' : '' }}</td>
                                    <td v-if="setReloj >= 0" class="whitespace-nowrap border-none" style="padding:0;">
                                        <div class="text-center">
                                            <BaseButton
                                                title="Eliminar"
                                                color="danger"
                                                small
                                                :icon="mdiTrashCan"
                                                @click="deleteRelojUser(client[0], client[1])"
                                            />
                                        </div>
                                        <!--label="Actualizar en Disp." <small @click="updateRelojUsers(client.id, client.apellidos + ' ' + client.nombres, claveRelojUser, rolRelojUser)" class="text-blue-700 hover:text-green-600">Actualizar en Disp.</small> -->
                                    </td>
                                </tr>
                                


                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    </BreezeAuthenticatedLayout>
</template>
<style scoped>
.vuecal__event {
    cursor: pointer;
}

.vuecal__event-title {
    font-size: 1.2em;
    font-weight: bold;
    margin: 4px 0 8px;
}

.vuecal__event-time {
    display: inline-block;
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

.vuecal__event-content {
    font-style: italic;
}
</style>
